import { Component, OnInit } from '@angular/core';
import { Produto } from 'src/app/base/domain/produto.model';
import { QueryOptions } from 'src/app/global/domain/query.options';
import { ProdutoService } from 'src/app/base/services/produto.service';
import { MatDialog } from '@angular/material/dialog';
import { AppState } from 'src/app/App.state';
import { DialogService } from 'src/app/global/services/dialog.service';
import { AcaoEvent, ListFilterOptions } from 'src/app/global/lists/produto-list/produto-list.component';
import { ReturnAPI, Page } from 'src/app/base/domain/return-api.model';
import { ProdutoFormComponent } from 'src/app/global/forms/produto-form/produto-form.component';

@Component({
  selector: 'app-produto-main',
  templateUrl: './produto-main.component.html',
  styleUrls: ['./produto-main.component.css'],
})
export class ProdutoMainComponent {
  private static DELETE_ACTION = 'Deletar produto';
  private static EDITAR_ACTION = 'Editar produto';

  produtos: Produto[];
  totalRecords = 0;

  queryOptions = new QueryOptions({ pageSize: 10, pageSort: '-id' });

  private postoSelecionado: number = null;

  constructor(private service: ProdutoService, public dialog: MatDialog, public appState: AppState, public dialogService: DialogService) {}

  mapearAcoes(produtos: Produto[]): void {
    const mapearAcoes = (produto: Produto): Produto => {
      const acoes = [];
      acoes.push(ProdutoMainComponent.EDITAR_ACTION);
      return { ...produto, acoes };
    };
    this.produtos = produtos?.map(mapearAcoes) ?? [];
  }

  list(page: number = 0): void {
    this.queryOptions.pageNumber = page;
    this.appState.isLoading = true;
    this.service.listPageable(this.queryOptions).subscribe(
      (response: Page<Produto>) => {
        if (response) {
          this.mapearAcoes(response.content);
          this.totalRecords = response.totalElements;
        }
        this.appState.isLoading = false;
      },
      () => (this.appState.isLoading = false),
    );
  }

  onLoad(pageNumber: number): void {
    this.list(pageNumber);
  }

  onDelete(produto: Produto): void {}

  onAcaoClick(event: AcaoEvent): void {
    const actions = new Map<string, (produto: Produto) => void>()
      .set(ProdutoMainComponent.DELETE_ACTION, (produto: Produto) => {
        this.dialogService.confirmDialog('Deseja realmente deletar esse produto?', () => this.onDelete(produto));
      })
      .set(ProdutoMainComponent.EDITAR_ACTION, (produto: Produto) => {
        this.onEdit(produto);
      });

    actions.get(event.acao)(event.produto);
  }

  onNovo(): void {
    this.dialog
      .open(ProdutoFormComponent, {
        data: {
          action: 'novo',
          produto: null,
        },
        width: '300px',
      })
      .afterClosed()
      .subscribe((result: Produto) => {
        if (result) {
          this.service.create(result).subscribe(
            () => {
              this.appState.isLoading = false;
              this.dialogService.feedbackSuccess('Operação realizada com sucesso!');
              this.list();
            },
            // tslint:disable-next-line: typedef
            (error) => {
              this.appState.isLoading = false;
              console.error(error);
              this.dialogService.feedbackError('Ocorreu um erro ao criar produto!');
              this.list();
            },
          );
        }
      });
  }

  onEdit(produto: Produto): void {
    this.dialog
      .open(ProdutoFormComponent, {
        data: {
          action: 'update',
          produto: produto,
        },
        width: '300px',
      })
      .afterClosed()
      .subscribe((result: Produto) => {
        if (result) {
          this.service.update(result).subscribe(
            () => {
              this.appState.isLoading = false;
              this.dialogService.feedbackSuccess('Operação realizada com sucesso!');
              this.list();
            },
            // tslint:disable-next-line: typedef
            (error) => {
              this.appState.isLoading = false;
              console.error(error);
              this.dialogService.feedbackError('Ocorreu um erro ao atualizar produto!');
              this.list();
            },
          );
        }
      });
  }

  onFilter(options: ListFilterOptions): void {
    const postoId = options.postoSelecionado ? options.postoSelecionado.id : null;
    this.queryOptions.params = {
      ...this.queryOptions.params,
      postoId,
    };

    this.list();

    if (postoId !== this.postoSelecionado) {
      this.postoSelecionado = postoId;
    }
  }
}
